import { fork } from "redux-saga/effects";

import watchAuthSaga from "../modules/login/services/LoginSaga";
import watchUserSaga from "../modules/user-management/services/UserSaga";
// import watchNotificationSaga from "../modules/admin/notification/services/NotificationSaga";
// import watchDataUploadCenterSaga from "../modules/admin/dataUploadCenters/services/DataUploadCenterSaga";
import watchDataCenterAutomationSaga from "../modules/dataCenterAutomation/services/DataCenterAutomationSaga";
import watchCommonSaga from "../modules/common/services/CommonSaga";
import watchInvestorSaga from "../modules/investor-management/services/InvestorSaga";
import watchDashboardSaga from "../modules/dashboard/services/DashboardSaga";
import watchDocumentSaga from "../modules/my-documents/services/DocumentSaga";
import watchCommunicationSaga from "../modules/communication/services/CommunicationSaga";
import watchDocumentTypeSaga from "../modules/documentMaster/services/documentMasterSaga";
import watchContentManagementSaga from "../modules/content-management/services/ContentManagementSaga";
import watchHoldCoSaga from "../modules/holdco/services/HoldCoSaga";
import watchEquityTypeDropdownSaga from "../modules/my-documents/services/EquityTypeSaga";

function* rootSaga() {
    yield fork(watchAuthSaga);
    yield fork(watchUserSaga);
    // yield fork(watchNotificationSaga);
    // yield fork(watchDataUploadCenterSaga);
    yield fork(watchDataCenterAutomationSaga);
    yield fork(watchCommonSaga);
    yield fork(watchInvestorSaga);
    yield fork(watchDocumentTypeSaga)
    yield fork(watchDashboardSaga);
    yield fork(watchDocumentSaga);
    yield fork(watchCommunicationSaga);
    yield fork(watchContentManagementSaga);
    yield fork(watchHoldCoSaga);
    yield fork(watchEquityTypeDropdownSaga);
}

export default rootSaga;